import React from "react";

export default function SectionHeading({ eyebrow, title, description, align = "center", light = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-[12px] font-medium tracking-wide uppercase ${
          light ? "border-brand-400/30 text-brand-300 bg-brand-400/10" : "border-brand-200 text-brand-700 bg-brand-50"
        }`}>
          <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
          {eyebrow}
        </div>
      )}
      <h2 className={`font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] ${light ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-[17px] leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>
          {description}
        </p>
      )}
    </div>
  );
}
